module.exports = __webpack_public_path__ + "img/tip1.1ca6531a.png";